import { Checkbox } from "../Checkbox/Checkbox";
import "./link.css";

export const Link = ({ type, href, children }) => {
  return (
    <span>
      {type === "checkbox-link" ? (
        <a href={href || "#"} className={type}>
          <Checkbox />
          {children}
        </a>
      ) : (
        <a href={href || "#"} className={type}>
          {children}
        </a>
      )}
    </span>
  );
};
